/**
 * One-intro-per-session gate.
 *
 * A brand-new talent used to be shown the Getting-Started video, the Profile
 * Boost promo AND the Community intro back-to-back on their first login —
 * four pop-ups to dismiss before they reached their dashboard / business card.
 *
 * These helpers let every intro/promo modal share a single sessionStorage
 * flag so only the FIRST eligible one appears per login session. Each modal
 * keeps its own long-term dismissal storage, so across sessions nothing nags.
 * Actionable prompts (e.g. shift confirmation) are intentionally NOT gated.
 */
const SESSION_KEY = 'ievntur_intro_modal_shown_session';

export function introShownThisSession() {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markIntroShownThisSession() {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    /* storage unavailable (Safari private mode) — fine, gate is best-effort */
  }
}
